// import React from 'react';
// import './barchart.css';

// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     return months
//       .filter((m) => monthMap[m]) 
//       .map((m) => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: 950, marginTop: '20px' }}>
//       <Paper elevation={0} sx={{ p: 3, border: '1px solid #ccc', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom>
//           Yearly Monthly Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={145}>
//           <BarChart margin={{ left: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12 }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`${year} Sales`}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;









// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", // Blue
//   "#ef6c00", // Orange
//   "#388e3c", // Green
//   "#d32f2f", // Red
//   "#7b1fa2", // Purple
//   "#fbc02d", // Yellow
//   "#0097a7", // Teal
//   "#5d4037", // Brown
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   const transformData = (data) => {
//     const monthMap = {};
//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     return months
//       .filter((m) => monthMap[m]) 
//       .map((m) => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%", marginTop: '20px' }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Yearly Monthly Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`${year} Sales`}
//                 barSize={20} // Controls the thickness of the bars
//                 radius={[10, 10, 0, 0]} // Rounded top corners of bars
//                 isAnimationActive={false}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;



// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// // const MonthlyComparisonChart = ({ data }) => {
// //   const months = [
// //     "January", "February", "March", "April", "May", "June",
// //     "July", "August", "September", "October", "November", "December"
// //   ];

// //   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

// //   const transformData = (data) => {
// //     const monthMap = {};
// //     data.forEach((item) => {
// //       const monthName = months[item.salesMonth - 1];
// //       if (!monthMap[monthName]) {
// //         monthMap[monthName] = { month: monthName };
// //       }
// //       monthMap[monthName][item.salesYear] = item.totalSales;
// //     });

// //     return months
// //       .filter((m) => monthMap[m]) 
// //       .map((m) => monthMap[m]);
// //   };

// //   const chartData = transformData(data);

// //   return (
// //     <Box sx={{ width: "100%"}}>
// //       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
// //         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
// //           Sales Comparison
// //         </Typography>

// //         <ResponsiveContainer width="100%" height={300}>
// //           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
// //             <XAxis
// //               dataKey="month"
// //               tick={{ fontSize: 12, fill: "#666" }}
// //               tickLine={{ stroke: "#ddd" }}
// //             />
// //             <YAxis
// //               ticks={[0, 200000, 400000, 1000000]}
// //               domain={[0, 1000000]}
// //               tickFormatter={(value) => value.toLocaleString('en-IN')}
// //               tickLine={{ stroke: "#ddd" }}
// //             />
// //             <Tooltip
// //               formatter={(value) => value.toLocaleString('en-IN')}
// //               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
// //             />
// //             <Legend
// //               verticalAlign="top"
// //               height={36}
// //               iconType="circle"
// //               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
// //             />
// //             {uniqueYears.map((year, index) => (
// //               <Bar
// //                 key={year}
// //                 dataKey={year}
// //                 fill={COLORS[index % COLORS.length]}
// //                 name={`${year} Sales`}
// //                 barSize={20} 
// //                 radius={[10, 10, 0, 0]} 
// //                 isAnimationActive={false}
// //               />
// //             ))}
// //           </BarChart>
// //         </ResponsiveContainer>
// //       </Paper>
// //     </Box>
// //   );
// // };

// const MonthlyComparisonChart = ({ data }) => {
//   // Financial year months in order (Apr to Mar)
//   const months = [
//     "April", "May", "June", "July", "August", "September",
//     "October", "November", "December", "January", "February", "March"
//   ];

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   const transformData = (data) => {
//     const monthMap = {};
    
//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
      
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
      
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     // Return months in financial year order
//     return months
//       .filter(m => monthMap[m])
//       .map(m => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Sales Comparison (Financial Year)
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
//                 barSize={20}
//                 radius={[10, 10, 0, 0]}
//                 isAnimationActive={false}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;




// import React from 'react';
// import './barchart.css';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", 
//   "#ef6c00", 
//   "#388e3c", 
//   "#d32f2f", 
//   "#7b1fa2", 
//   "#fbc02d", 
//   "#0097a7", 
//   "#5d4037", 
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   // Financial year months in order (Apr to Mar)
//   const months = [
//     "April", "May", "June", "July", "August", "September",
//     "October", "November", "December", "January", "February", "March"
//   ];

//   // Define the years you want to display
//   const targetYears = [2025, 2026];  // Only show data for FY 2025-26, FY 2026-27

//   const uniqueYears = [...new Set(data.map(item => item.salesYear))]
//     .filter(year => targetYears.includes(year)) // Filter only the target years
//     .sort();

//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];

//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }

//       // Include only the target years' data
//       if (targetYears.includes(item.salesYear)) {
//         monthMap[monthName][item.salesYear] = item.totalSales;
//       }
//     });

//     // Return months in financial year order
//     return months
//       .filter(m => monthMap[m])
//       .map(m => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
//           Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={300}>
//           <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{ fontSize: 12, fill: "#666" }}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <YAxis
//               ticks={[0, 200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value.toLocaleString('en-IN')}
//               tickLine={{ stroke: "#ddd" }}
//             />
//             <Tooltip
//               formatter={(value) => value.toLocaleString('en-IN')}
//               contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
//             />
//             <Legend
//               verticalAlign="top"
//               height={36}
//               iconType="circle"
//               wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
//             />
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
//                 barSize={20}
//                 radius={[10, 10, 0, 0]}
//                 isAnimationActive={false}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>
//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;


import React from 'react';
import './barchart.css';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Paper, Typography, Box } from "@mui/material";

const COLORS = [
  "#1976d2", 
  "#ef6c00", 
  "#388e3c", 
  "#d32f2f", 
  "#7b1fa2", 
  "#fbc02d", 
  "#0097a7", 
  "#5d4037", 
];

const MonthlyComparisonChart = ({ data }) => {
  const months = [
    "April", "May", "June", "July", "August", "September",
    "October", "November", "December", "January", "February", "March"
  ];

  const targetYears = [2025, 2026];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth(); 

  const uniqueYears = [...new Set(data.map(item => item.salesYear))]
    .filter(year => targetYears.includes(year)) 
    .sort();

  const transformData = (data) => {
    const monthMap = {};

    data.forEach((item) => {
      const monthName = months[item.salesMonth - 1];
      let salesYear = item.salesYear;
      if (item.salesMonth === 1 || item.salesMonth === 2 || item.salesMonth === 3) {
        salesYear = item.salesYear - 1;
      }

      if (!monthMap[monthName]) {
        monthMap[monthName] = { month: monthName };
      }

      if (targetYears.includes(salesYear)) {
        monthMap[monthName][salesYear] = item.totalSales;
      }
    });

    return months
      .filter((month, index) => {
        if (currentYear === 2025 && index > currentMonthIndex) {
          return false; 
        }
        return currentYear === 2025 || (currentYear === 2026 && index < 12);
      })
      .map((month) => {
        return monthMap[month] || { month, 2025: 0, 2026: 0 }; 
      });
  };

  const chartData = transformData(data);

  return (
    <Box sx={{ width: "100%" }}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "#333" }}>
          Sales Comparison
        </Typography>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart margin={{ left: 20, right: 20, bottom: 5 }} data={chartData}>
            <XAxis
              dataKey="month"
              tick={{ fontSize: 12, fill: "#666" }}
              tickLine={{ stroke: "#ddd" }}
            />
            <YAxis
              ticks={[0, 200000, 400000, 1000000]}
              domain={[0, 1000000]}
              tickFormatter={(value) => value.toLocaleString('en-IN')}
              tickLine={{ stroke: "#ddd" }}
            />
            <Tooltip
              formatter={(value) => value.toLocaleString('en-IN')}
              contentStyle={{ backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "5px" }}
            />
            <Legend
              verticalAlign="top"
              height={36}
              iconType="circle"
              wrapperStyle={{ lineHeight: "40px", fontSize: "12px", color: "#333" }}
            />
            {uniqueYears.map((year, index) => (
              <Bar
                key={year}
                dataKey={year}
                fill={COLORS[index % COLORS.length]}
                name={`FY ${year}-${(year + 1).toString().slice(-2)}`}
                barSize={20}
                radius={[10, 10, 0, 0]}
                isAnimationActive={false}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Box>
  );
};

export default MonthlyComparisonChart;